<script setup lang="ts">
import { computed, type PropType } from 'vue';
import {
    fieldPropDefs,
    useFieldProps,
} from '@precon-tools-suite-by-shared/shared-common-forms-ui';
import Dropdown from 'primevue/dropdown';
import { RiskValueBadgeInput } from './RiskValueBadge.vue';
import { RiskValueBadge } from '..';

const props = defineProps({
    ...fieldPropDefs,
    modelValue: {
        type: [Number] as PropType<number | undefined | null>,
        default: undefined,
    },
    options: {
        type: Array as PropType<Array<RiskValueBadgeInput>>,
        default: () => [],
    },
    placeholder: {
        type: String,
        default: 'Selecteer een waarde',
    },
    showClear: {
        type: Boolean,
        default: false,
    },
    allowEditing: {
        type: Boolean,
        default: true,
    },
});
const emit = defineEmits(['update:modelValue']);
const { id, name, fieldProps, modelValue } = useFieldProps(props, emit);

const options = computed(() => props.options.map((x) => x?.value));

function getInputValuesFor(value: number | null | undefined) {
    return props.options.find(
        (x) => x.value?.toLocaleString() === value?.toLocaleString()
    );
}
</script>

<template>
    <Field v-bind="fieldProps">
        <template #readonly>
            <RiskValueBadge :input="getInputValuesFor(modelValue)" />
        </template>
        <Dropdown
            v-if="allowEditing"
            v-model="modelValue"
            v-bind="$attrs"
            :options="options"
            :placeholder="placeholder ?? 'Selecteer waarde'"
            :name="name"
            :input-id="id"
            :class="props.inputClass"
            :style="props.inputStyle"
        >
            <template #value="{ value }">
                <RiskValueBadge :input="getInputValuesFor(value)" />
            </template>
            <template #option="{ option }">
                <RiskValueBadge :input="getInputValuesFor(option)" />
            </template>
        </Dropdown>
        <RiskValueBadge v-else :input="getInputValuesFor(modelValue)" />
    </Field>
</template>
